import { render, staticRenderFns } from "./printAllocationStorehouseList.vue?vue&type=template&id=c14af660&scoped=true"
import script from "./printAllocationStorehouseList.vue?vue&type=script&lang=js"
export * from "./printAllocationStorehouseList.vue?vue&type=script&lang=js"
import style0 from "./printAllocationStorehouseList.vue?vue&type=style&index=0&id=c14af660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c14af660",
  null
  
)

export default component.exports